import Alert from './Alert'
export default class DestroyAlert extends Alert{
    show() {
        return new Promise((resolve, reject) => {
            swal({
                title: uLang('app.are_you_sure'),
                text: this.key('text', lang('app.delete_warning_entity_het', { entity: this.key('entity') })) ,
                icon: "warning",
                buttons: [uLang('app.cancel'), uLang('app.continue')],
                dangerMode: true,
                closeOnClickOutside: false,
                closeOnEsc: false,
            })
            .then((willDelete) => {
                if (willDelete) {
                    return resolve();
                }
            }).catch(() => {
                reject();
            });
        });

    }
}
